export default __webpack_public_path__ + "static/media/customer-service.52a3928d.svg";